export default __webpack_public_path__ + "static/media/cyan beret.08986af8.png";